import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { ApplicationResponse } from '../../models/stack9/ApplicationResponse';
import { ResponseForm } from './ResponseForm';

const { ScreenProvider } = ui;
const S9Drawer = ui.S9Drawer.default;

type ResponseDrawerProps = {
  id: number;
  open: boolean;
  onClose: () => void;
  initialValues?: Partial<ApplicationResponse>;
};

export const ResponseDrawer = ({
  id,
  open,
  onClose,
  initialValues,
}: ResponseDrawerProps) => (
  <ScreenProvider relativePath={AppRoutes.ApplicationDetail}>
    <S9Drawer open={open} width={650} onClose={onClose} closable>
      <ResponseForm initialValues={initialValues} id={id} onClose={onClose} />
    </S9Drawer>
  </ScreenProvider>
);
